import { DeleteDialog } from "@features/project-detail/ui/DeleteDocumentDialog";
import { useCallback } from "react";
import { useOverlay } from "./useOverlay";

interface DeleteConfirmDialogOptions {
  title?: string;
  description?: string;
  onDelete: () => Promise<void>;
}

export function useDeleteConfirmDialog() {
  const { open, close } = useOverlay();

  const openDeleteDialog = useCallback(
    ({ title, description, onDelete }: DeleteConfirmDialogOptions) => {
      open(({ isOpen, close }) => (
        <DeleteDialog open={isOpen} onClose={close} onDelete={onDelete} title={title} description={description} />
      ));
    },
    [open],
  );

  return { openDeleteDialog, close };
}
